var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExportScorm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61832 2.68278L17.67 7.87077C17.9454 8.01289 18.1193 8.29606 18.1214 8.60597C18.1235 8.91588 17.9535 9.20138 17.68 9.34722L13.9285 11.3481C13.4452 11.6058 12.8662 11.6099 12.3795 11.3589L2.33029 6.16923C2.05488 6.0271 1.88104 5.74394 1.87893 5.43403C1.87684 5.12412 2.04683 4.83862 2.32028 4.69278L6.07185 2.69195C6.55467 2.43556 7.1325 2.43213 7.61832 2.68278Z",
    stroke: "#3D8BF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.382 2.68278L2.33029 7.87077C2.05488 8.01289 1.88104 8.29606 1.87893 8.60597C1.87684 8.91588 2.04683 9.20138 2.32028 9.34722L6.07185 11.3481C6.55506 11.6058 7.13405 11.6099 7.62083 11.3589L17.67 6.16923C17.9454 6.0271 18.1193 5.74394 18.1214 5.43403C18.1235 5.12412 17.9535 4.83862 17.68 4.69278L13.9285 2.69195C13.4456 2.43556 12.8678 2.43213 12.382 2.68278Z",
    stroke: "#3D8BF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9232 10.2843V13.5657C15.9232 14.1816 15.5838 14.7473 15.0404 15.0371L10.7886 17.3072C10.2983 17.5687 9.70992 17.5687 9.2196 17.3072L4.96783 15.0371C4.42436 14.7473 4.08496 14.1816 4.08496 13.5657V10.2843",
    stroke: "#3D8BF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5032V10.1284",
    stroke: "#3D8BF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExportScorm);
export default ForwardRef;